import { createSlice } from "@reduxjs/toolkit";
import { getPromoCodes } from "./promoCodeActions";

const initialState = {
  loading: false,
  error: null,
  codes: {},
  success: false,
};

const promoCodesSLice = createSlice({
  name: "promoCodes",
  initialState,
  reducers: {
    resetPromoCodesError: (state, action) => {
      if (action?.payload) {
        delete state.error[action?.payload];
        if (Object.keys(state.error)?.length === 0) {
          state.error = null;
        }
      } else {
        state.error = null;
      }
      state.loading = false;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPromoCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPromoCodes.fulfilled, (state, action) => {
        state.loading = false;
        state.codes = action.payload;
      })
      .addCase(getPromoCodes.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});
export const { resetPromoCodesError } = promoCodesSLice.actions;
export default promoCodesSLice.reducer;
